import * as hangul from "hangul-js";
import { LOCALES } from "../constants";

const CHOSUNG = ["ㄱ", "ㄲ", "ㄴ", "ㄷ", "ㄸ", "ㄹ", "ㅁ", "ㅂ", "ㅃ", "ㅅ", "ㅆ", "ㅇ", "ㅈ", "ㅉ", "ㅊ", "ㅋ", "ㅌ", "ㅍ", "ㅎ"];

let regex;
let query;

const getChosungRange = (chosungChar) => {
    const choIndex = CHOSUNG.indexOf(chosungChar);
    if (choIndex === -1) return null;

    const startCode = 0xac00 + choIndex * 21 * 28;
    const endCode = 0xac00 + (choIndex + 1) * 21 * 28 - 1;

    return `[${String.fromCharCode(startCode)}-${String.fromCharCode(endCode)}]`;
};

const registQuery = (lang, q) => {
    if (q === "") return false;
    query = q;

    // searcher
    if (lang === LOCALES.KO) {
        const tmp = hangul
            .disassemble(q.replaceAll(/\s/g, ""), true)
            .map((e) => {
                if (hangul.isConsonantAll(e.join(""))) return e.map((cho) => `(${getChosungRange(cho)})`).join("");
                else return hangul.assemble(e);
            })
            .join("");

        regex = new RegExp(tmp, "i");
    } else {
        const tmp = q
            .split(" ")
            // .map((keyword) => `(${keyword}`)
            .join("\\s*");

        regex = new RegExp(tmp, "i");
    }

    return true;
};

const choSearch = (text) => {
    // text fiter white space
    const tmp = text.replaceAll(/\s/g, "");

    // search
    return regex.test(tmp);
};

export { registQuery, choSearch };
